export default __webpack_public_path__ + "static/media/zumi.c48d3006.jpg";